import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconClip$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconClip extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '385c5d74de6dbbe79e6c2f5795b2731b45e1b175', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4b707edaccb2d0a4b844fa6dfa6e90f72bc10493', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'dd05eb6114cdff931f415ac833168e2141eceead', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M9.14 14.254A.3.3 0 0 1 9 14V8a.3.3 0 0 1 .43-.27l5 3a.3.3 0 0 1 0 .54l-5 3a.3.3 0 0 1-.29-.016", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-clip", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-clip"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-clip":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconClip$1);
            }
            break;
    } });
}

const CosmosIconClip = CosmosIconClip$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconClip, defineCustomElement };
